import React, { useState } from 'react';
import styled from 'styled-components';
import { mediaBreakpointDown } from '../../utils/styling';
import Time from '../../images/time-logo.png';
import StarIcon from '../../images/custom-cta-star.inline.svg';
import { trackCustomEvent } from "gatsby-plugin-google-analytics";

const Background = styled.div`
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	width: 100%;
	padding: 25px;
	border-radius: 10px;
	background-color: #222f68;

	display: flex;
	align-items: center;
	width: 100%;

	${mediaBreakpointDown('md')} {
		padding: 25px;
	}
	${mediaBreakpointDown('sm')} {
		padding: 25px;
		margin-bottom: 0;
	}
`;

const BackgroundContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;

	${mediaBreakpointDown('sm')} {
		flex-direction: column;
		margin-bottom: 0;
		padding-bottom: 0;
	}
`;

const Form = styled.form`
	flex-basis: 50%;
	width: 100%;
`;

const FormContainer = styled.div`
	width: 100%;
	${mediaBreakpointDown('sm')} {
		margin: auto;
	}

	display:flex;
	align-items:center;
	justify-content:center;
`;

const Title = styled.div`
	font-weight: bold;
	color: #fff;
	font-size: 25px;
	margin: 0 0 10px 0;

	${mediaBreakpointDown('sm')} {
		text-align: center;
		font-size: 25px;
		margin: 0 0 10px 0;
	}

	${mediaBreakpointDown('md')} {
		font-size: 25px;
		margin: 0 0 10px 0;
	}
`;
const InputWrapper = styled.div`
	flex-basis: 50%;
	${mediaBreakpointDown('md')} {
		flex-basis: 60%;
	}
	${mediaBreakpointDown('sm')} {
		flex-basis: 90%;
	}
`;
const InputContainer = styled.div`
	display: flex;
	background-color: #ffffff;
	border-radius: 8px;
	align-items: center;
	margin-bottom: 18px;

	> svg {
		margin-left: 13px;
		margin-right: 5px;
	}
`;
const Input = styled.input`
	border: none;
	outline: none;
	background: transparent;
	font-weight: 600;
	font-size: 16px;
	flex: 1 1;
	padding: 13px;
	width: 100%;
`;

const ButtonContainer = styled.button`
	background-color: #e01efe;
	color: #fffffff6;
	padding: 14px 20px;
	border-radius: 8px;
	font-weight: bold;
	font-size: 14px;
	width: 100%;
	text-align: center;
	cursor: pointer;
`;

const Testinomial = styled.div`
	flex-basis: 50%;
	padding: 0 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-evenly;

	${mediaBreakpointDown('md')} {
		padding: 0 20px;
	}

	${mediaBreakpointDown('sm')} {
		display: none;
	}
`;
const Star = styled.div`
	margin-bottom: 5px;
`;
const Text = styled.p`
	font-weight: bold !important;
	font-size: 16px !important;
	color: #fff !important;
	text-align: center;
	margin: 0 0 10px 0 !important;
`;
const Image = styled.img`
	width: 125px;
	height: 35px !important;
	margin: 0 !important;
`;
const Disclaimer = styled.div`
	font-size: 12px;
	color: #fff;
	line-height: 1.5;
	margin-top: 10px;

	> span {
		text-decoration: underline;
	}
`;


function CTAForm({ cta, title, button = 'Sign up for DoNotPay', testimonial = 'The Hero The World Needs.' }) {
	const [email, setEmail] = useState('');
	const validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
		email,
	);

	return (
		<Background className={'ctaForm'}>
			<BackgroundContainer>
				<Form
					onSubmit={(e) => {
						e.preventDefault();
						// trackCustomEvent({
						// 	category: "Entire page tracker",
						// 	action: "click",
						// 	label: "Submit Form",
						// });
						// trackCustomEvent({
						// 	category: "In-content CTAs clicks",
						// 	action: "click",
						// 	label: "Submit Form",
						// })
						if (validEmail) {
							window.location.href = `${process.env.MAIN_SITE_URL}/${cta}?email=${encodeURIComponent(email)}`;
						}
					}}
				>
					<Title>{title || 'Solve your problem'}</Title>
					<FormContainer>

						<InputWrapper>
							<InputContainer>
								<Input
									value={email}
									placeholder="Enter your email"
									onChange={(e) => setEmail(e.target.value.toLowerCase().replace(/\s/g, ''))}
								/>
							</InputContainer>

							<ButtonContainer type="submit" className="cta-form-ga">
								{button || 'Sign up'}
							</ButtonContainer>
						</InputWrapper>
						<Testinomial>
							<Star>
								<StarIcon />
							</Star>
							<Text>&ldquo;{testimonial}&rdquo;</Text>
							<div>
								<Image alt="Time" src={Time} />
							</div>
						</Testinomial>
					</FormContainer>
				</Form>
				<Disclaimer>
					By signing up or signing in, you are agreeing to      <a style={{ color: "#7d8ae1" }} href="https://donotpay.com/learn/terms-of-service/">
						DoNotPay&apos;s Terms and Conditions
					</a> and  <a style={{ color: "#7d8ae1" }} href="https://donotpay.com/learn/privacy-policy/">
						Privacy Policy
					</a> and for us to send messages to
					the phone number or email provided. These terms contain an arbitration agreement; please read them carefully.
					These blog posts represent the opinion of DoNotPay’s Writers, but each person’s situation and circumstances vary greatly. As a result, you should make sure to do your own independent research. <span>Because everyone is unique, our self-help tools are never guaranteed to help with any specific situation.</span> DoNotPay is not a law firm, is not licensed to practice law, and is not equivalent to the services of a licensed lawyer. DoNotPay provides a platform for legal information and self-help, and does not offer legal services.
					Third party news articles mentioned on our website do not necessarily reflect the views of the company, or the current services that we offer.
				</Disclaimer>
			</BackgroundContainer>
		</Background>
	);
}

export default React.memo(CTAForm);
